export const AGENCY_PRICES_KEY = [
  "v2",
  "agency_manager",
  "agency_pricing",
  "products_prices"
]
